import { useEffect, useRef } from "react";
import type { SignInSurface } from "./events";
import { track } from "./telemetry";

/** Fire `sign_in_prompt_shown` once per mount, the first time `visible` is true. */
export function useSignInPromptShown(surface: SignInSurface, visible = true): void {
  const fired = useRef(false);
  useEffect(() => {
    if (!visible || fired.current) return;
    fired.current = true;
    track("sign_in_prompt_shown", { surface });
  }, [surface, visible]);
}
